<template>
  <div id="card-comment">
    <div class="row mt-3">
      <div class="col-md-1 col-xs-12">
        <div class="user-pic">
          <img
            alt="Profile Image"
            :data-src-retina="data.img_picture | showPicture"
            :data-src="data.img_picture | showPicture"
            :src="data.img_picture | showPicture"
            @error="imageProfileUrlAlt"
            class="img-circle"
          />
        </div>
      </div>
      <div class="col-md-11">
        <div class="row">
          <div class="col-10 ml-3">
            <div class="d-flex align-items-center post-meta p-t-5">
              <span
                class="pull-left account-name"
                style="cursor: pointer !important"
              >
                <b>{{ data.user.username }}</b>
              </span>
            </div>
          </div>
          <div class="col-10 ml-3">
            <p class="text-justify" v-html="content(this.data.text)"></p>
          </div>
          <span class="pull-right col-12 ml-3">
            <i class="bi bi-heart-fill mr-2"></i>
            <span class="mr-1">
              {{ data.comment_like_count | kmbFormatter }}
            </span>
            <i class="bi bi-chat-dots-fill ml-1 mr-2"></i>
            <span> {{ data.child_comment_count | kmbFormatter }} </span>
            <i class="bi bi-clock-history-o ml-1"></i>
            <span> {{ (data.created_at * 1000) | dateIndonesia }} </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gp from "@/plugins/generalPlugins.js";
export default {
  name: "instagram_comment",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    imageProfileUrlAlt: function () {
      event.target.src = "/assets/img/profiles/default.png";
    },
    content: function (text) {
      return this.$parent.writeContent(text);
    },
  },
  filters: {
    showPicture: function (post, source) {
      let pro_pic;
      switch (source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "instagram":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        case "youtube":
          pro_pic = post.thumbnails;
          break;
        case "linkedin":
          pro_pic = post.profile_picture;
          break;
        case "tiktok":
          pro_pic = post.profile_picture;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function (number) {
      return gp.kmbFormatter(number);
    },
    dateIndonesia: function (date) {
      return gp.dateIndonesia(date);
    },
  },
};
</script>

<style  scoped>
.user-pic {
  width: 40px !important;
  height: 40px !important;
  position: relative;
}
.img-circle {
  height: 40px !important;
  width: 40px !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 50px;
  max-width: 50px;
}
</style>